import BaseIcon from "./BaseIcon";

const SlipIcon = ({ data }) => (
  <BaseIcon {...data} style={{ width: "0.5em", height: "1.5em" }} />
);

export default SlipIcon;
